import React from 'react';
import { Link } from 'react-router-dom';
import { Camera, Award, Users, Heart } from 'lucide-react';
import './About.css';

const About = () => {
  return (
    <div className="about-container">
      <section className="page-header">
        <div className="container">
          <h1>About PlayMaker Pics</h1>
          <p>Our mission is to revolutionize sports photography for teams and events</p>
        </div>
      </section>

      <section className="about-intro">
        <div className="container">
          <div className="intro-content">
            <div className="intro-text">
              <h2>Our Story</h2>
              <p>
                PlayMaker Pics was founded in 2022 by a team of sports photographers and technology experts who saw an opportunity to transform how sports photography is created, managed, and shared.
              </p>
              <p>
                After spending years documenting sporting events and seeing the challenges teams faced with image management, we built a platform that combines powerful AI technology with intuitive design to make professional sports photography accessible to everyone.
              </p>
              <p>
                Today, our platform serves thousands of teams, athletes, and events across the country, helping them capture and celebrate their most important moments.
              </p>
            </div>
            <div className="intro-image">
              <img src="/images/about-team.jpg" alt="PlayMaker Pics Team" />
            </div>
          </div>
        </div>
      </section>

      <section className="values-section">
        <div className="container">
          <h2 className="section-title">Our Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <Camera size={32} />
              </div>
              <h3>Quality</h3>
              <p>We believe in delivering professional-grade images that athletes and teams can be proud of.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <Award size={32} />
              </div>
              <h3>Excellence</h3>
              <p>We strive for excellence in every aspect of our platform, from our AI technology to customer support.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <Users size={32} />
              </div>
              <h3>Community</h3>
              <p>We're building more than a product—we're creating a community of sports photographers and enthusiasts.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <Heart size={32} />
              </div>
              <h3>Passion</h3>
              <p>We're passionate about sports and the moments that make them special. That passion drives everything we do.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="team-section">
        <div className="container">
          <h2 className="section-title">Our Team</h2>
          <div className="team-grid">
            <div className="team-member">
              <div className="member-image">
                <img src="/images/team-member1.jpg" alt="Team Member" />
              </div>
              <h3>Alex Johnson</h3>
              <p className="member-title">CEO & Co-Founder</p>
              <p className="member-bio">Former sports photographer with 15+ years of experience capturing major sporting events.</p>
            </div>
            <div className="team-member">
              <div className="member-image">
                <img src="/images/team-member2.jpg" alt="Team Member" />
              </div>
              <h3>Sarah Chen</h3>
              <p className="member-title">CTO & Co-Founder</p>
              <p className="member-bio">AI specialist with a background in computer vision and image processing technology.</p>
            </div>
            <div className="team-member">
              <div className="member-image">
                <img src="/images/team-member3.jpg" alt="Team Member" />
              </div>
              <h3>Michael Rodriguez</h3>
              <p className="member-title">Head of Product</p>
              <p className="member-bio">Former collegiate athlete with a passion for creating intuitive user experiences.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to join our community?</h2>
            <p>Start capturing and sharing your sports moments today.</p>
            <div className="cta-buttons">
              <Link to="/register" className="cta-button">Get Started</Link>
              <Link to="/contact" className="cta-button secondary">Contact Us</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 